import actionsInfo from "../assets/meq-docs/userActionCodes.json";

function getUserActionInfo(code){
    if(!code){
        return false;
    }
    return actionsInfo?.actionsCode.find(action => action.code === code);
}

export default getUserActionInfo;